import React from "react";
import { useNavigate } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

function AdminPage() {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      {/* Header */}
      <h1 style={styles.title}>Admin Page</h1>

      {/* Button Group */}
      <div style={styles.buttonGroup}>
        <button
          style={styles.button}
          onClick={() => navigate('/business')}
        >
          Add Business
        </button>

        <button
          style={styles.button}
          onClick={() => navigate('/add-cocktail')}
        >
          Add Cocktail
        </button>

        <button
          style={styles.button}
          onClick={() => navigate('/manage-bars')}
        >
          Edit Cocktails
        </button>

        <button
          style={styles.button}
          onClick={() => navigate('/create-qr')}
        >
          Create QR Code
        </button>
  
        <button
          style={styles.button}
          onClick={() => navigate('/messages')}
        >
          See Messages
        </button>

      </div>

      {/* Footer Section */}
      <footer style={styles.footer}>
        <p style={styles.vision}>
          <strong>VISION</strong> by <strong>Metron Ariston</strong><sup>™</sup>
        </p>
        <p style={styles.copyright}>
          © 2024 Created & Published by METRON ARISTON · Making Responsibility a Trend™
        </p>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: blue,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    color: "#ffffff",
    fontFamily: "'Segoe UI', sans-serif",
    textAlign: "center",
  },
  title: {
    fontSize: "42px",
    marginBottom: "40px",
    fontWeight: "700",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
    maxWidth: "320px",
  },
  button: {
    backgroundColor: yellow,
    color: blue,
    fontSize: "18px",
    fontWeight: "bold",
    padding: "14px 20px",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  footer: {
    marginTop: "60px",
    fontSize: "14px",
    color: "#d3d3d3",
  },
  vision: {
    fontSize: "18px",
    marginBottom: "8px",
    color: "#ffffff",
  },
};

export default AdminPage;
